import '../../../../styles/StayUptoDateCSS/StayUpToDateControls.css'
import { updateComponent } from "../../../../Utils/SupabaseServices/StayUpToDateDatabase";
import EditCustomFeedComponent from "./EditCustomFeedComponent";
import { validateTitleForEdit } from "../../../../Utils/helpers/carouselHelper";
import { useEffect } from 'react';
import { useState } from 'react';
import { Modal } from 'antd';

const EditCustomContent = (props: any) => {
  const {
    username,
    user_id,
    isContentEditModalOpen,
    type,
    component,
    refetch,
    initial,
    setInitial,
    from
  } = props;
  const [name, setName] = useState(component.name || "");
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [postIds, setPostIds] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [defaultQuery, setDefaultQuery] = useState("");
  const [isChange, setIsChange] = useState(false);
  const [activeFilter, setActiveFilter] = useState("both");
  const [isSoundOn, setIsSoundOn] = useState(component.content_sound || false);
  const [shape, setShape] = useState(component.content_shape || "rect");
  const [order, setOrder] = useState("DESC");

  const [edit, setEdit] = useState(false);
  const [editIndex, setEditIndex] = useState("");
  useEffect(() => {
    // if (isContentEditModalOpen) {
    setInitial((prev: any) => !prev);
    // }
  }, [isContentEditModalOpen]);
  useEffect(() => {
    setName(component?.name);
    setPostIds(component?.post_ids);
    // setDefaultQuery(component?.query);
    setShape(component.content_shape);
    setIsSoundOn(component.content_sound)
  }, [component]);

  const handleInputChange = (value: string, setter: Function) => {
    setter(value);
    setIsButtonDisabled(!value);
  };
  const handleOk = async () => {

    if(errorMsg){
      return;
    }

    if (!name.trim()) {
      setErrorMsg("Title is required");
      return;
    }
    // Validate the new title
    const validation = validateTitleForEdit(name, component);
    if (!validation.isValid) {
      setErrorMsg(validation.error || "Invalid title");
      return;
    }

    setConfirmLoading(true);
    const res = await updateComponent(
      name,
      component,
      username,
      user_id,
      defaultQuery,
      "content",
      postIds.toString(),
      "", "", order, shape, isSoundOn, undefined, from
    );
    if (res === "true") {
      props.refetch();

      props.setIsContentEditModalOpen(false);
      props.setSelectedComponent("");
      setConfirmLoading(false);
      setInitial((prev: any) => !prev);

      // props.setIsCustomContentComponentOpen(false);
      setName("");
      setPostIds("");
      setErrorMsg("");
      setDefaultQuery("");
      setIsChange(false);
      setActiveFilter("both")
      setEdit(false)
      setEditIndex("")

    } else {
      setErrorMsg("Category with this name already exist.");
      setConfirmLoading(false);
      // setEdit(false)
      setEditIndex("")
    }
    // props.refetch();
  };

  const handleCancel = () => {
    setInitial((prev: any) => !prev);

    props.setIsContentEditModalOpen(false);
    props.setSelectedComponent("");
    props.refetch();
    setName("");
    setPostIds("");
    setErrorMsg("");
    setDefaultQuery("");
    setActiveFilter("both")
    setEdit(false)
    setEditIndex("")

  };
  function handlePostIds(post_ids: any) {
    setPostIds(post_ids);
  }

  return (
    <>
      <Modal
        open={isContentEditModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        okText="Update"
        confirmLoading={confirmLoading}
        okButtonProps={{ disabled: !name }}
        data-testid="edit-content-carousel"
        focusTriggerAfterClose={false}
        getContainer={false}
        style={{ top: "15px" }}
      >
        <div>
          <h5 className="fontsize-16">Editing {name}</h5>

          {errorMsg && <p className="errorMsg text-center">{errorMsg}</p>}
          <label className="bold-label fontsize-12">Preview</label>

          <EditCustomFeedComponent
            username={username}
            user_id={user_id}
            component={component}
            defaultQuery={defaultQuery}
            initial={initial}
            setInitial={setInitial}
            isModalOpen={isContentEditModalOpen} // Pass modal open state here
            handleFeed={handlePostIds}
            type="content"
            activeFilter={activeFilter}
            setActiveFilter={setActiveFilter}
            setDefaultQuery={setDefaultQuery}
            isSoundOn={isSoundOn}
            setIsSoundOn={setIsSoundOn}
            shape={shape}
            setShape={setShape}
            // order={order}
            // setOrder={setOrder}
            edit={edit}
            setEdit={setEdit}
            editIndex={editIndex}
            setEditIndex={setEditIndex}
            name={name}
            setName={setName}
            errorMsg={errorMsg}
            setErrorMsg={setErrorMsg}
          />
        </div>
        {/* <p>Your component will be ready within 24 hours!</p> */}
      </Modal>
    </>
  );
};

export default EditCustomContent;
